import { useMutation } from '@tanstack/react-query';
import { useAxiosWithoutToken } from '../../../api/axios';
import { useTranslation } from 'react-i18next';

interface otpData {
  otp: string;
}

export const useInvestorOTP = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const axios = useAxiosWithoutToken();
  const { t } = useTranslation();
    const urlKey = t('investor-otp-verification');
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: otpData) => {
      const response = await axios.post(urlKey, data);
      return response.data;
    },
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    },
  });
};
